export const LEGAL_IMPRINT_HEADING: string = `

<center>
 <h1 style="margin-bottom: 0">Impressum / Rechtliche Hinweise</h1>
 Rechtspersönlichkeit und Verantwortung
</center>

---

## Legal Identity

`;
